import { motion, Variants } from "framer-motion";
import { useMedia } from "react-use";
import styled, { css, useTheme } from "styled-components";
import { easings } from "../../styles/utils";

interface MenuWrapperProps {}

const Wrapper = styled(motion.div)`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: calc(100% - 80px);
  left: 0;
  background-color: ${({ theme }) => theme.colors.hotPink};
  z-index: 10;
  color: ${({ theme }) => theme.colors.white};

  /* svg {
    color: ${({ theme }) => theme.colors.blueDark};
  } */

  ${({ theme }) => css`
    ${theme.mediaQueries.md} {
      z-index: -1;
      width: calc(100vw - 200px);
      height: 100vh;
      /* left: 100%; */
    }
  `}
`;

const smallVariants: Variants = {
  animate: {
    x: 0,
    y: 0,
    transition: {
      duration: 0.6,
      when: "beforeChildren",
      ease: easings.easeOutCubic,
    },
  },
  exit: {
    x: 0,
    y: "100%",
    transition: {
      duration: 0.6,
      delay: 0.3,
      ease: easings.easeOutCubic,
    },
  },
};

const wideVariants: Variants = {
  animate: {
    x: "200px",
    y: 0,
    transition: {
      duration: 0.6,
      when: "beforeChildren",
      ease: easings.easeOutCubic,
    },
  },
  exit: {
    x: "100%",
    y: 0,
    transition: {
      duration: 0.6,
      delay: 0.6,
      ease: easings.easeOutCubic,
    },
  },
};

export const MenuWrapper: React.FC<MenuWrapperProps> = ({ children }) => {
  const theme = useTheme();
  const isWide = useMedia(`(min-width: ${theme.breakpoints[1]})`);

  return (
    <Wrapper
      variants={isWide ? wideVariants : smallVariants}
      initial="exit"
      animate="animate"
      exit="exit"
    >
      {children}
    </Wrapper>
  );
};
